import { GlobalStyle } from "global/styled/GlobalStyle";
import RouterSegundoFactor from "./routes/routes";

const SegundoFactorContainer = ({ match }) => {
  let config = localStorage.getItem("config");
  let modoEstilo = JSON.parse(config).modoEstilo;
  return (
    <>
      <GlobalStyle mode={modoEstilo} />
      <RouterSegundoFactor match={match} />
    </>
  );
};

export default SegundoFactorContainer;
